// Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved.

import i18n from "@/i18n";
import { computed } from "vue";

export const restrictedCountry = {
    validationFunction: (value: any) => {
        if (!value || typeof value !== 'object') {
            return true;
        }
        return value.value.isRestricted === false;
    },
    errorMessageText: computed(() => i18n.global.t('validation.messages.restrictedCountry')),
};

export const apacOnlyCountry = {
    validationFunction: (value: any) => {
        if (!value || typeof value !== 'object') {
            return true;
        }
        return value.value.region !== 'APAC';
    },
    errorMessageText: computed(() => i18n.global.t('validation.messages.apacOnlyCountry')),
};

export const differentRegion = (oldRegion: any) => {
    return {
        validationFunction: (value: any) => {
            if (!value || typeof value !== 'object') {
                return true;
            }
            const initialRegion = oldRegion;
            return !initialRegion || value.value.region === initialRegion;
        },
        arguments: [oldRegion],
        errorMessageText: computed(() => i18n.global.t('validation.messages.differentRegion')),
    };
};

export const disabledCountry = {
    validationFunction: (value: any) => {
        if (!value || typeof value !== 'object') {
            return true;
        }
        return (
            window.allowDisabledCountries === true ||
            value.value.isActive === true
        )
    },
    errorMessageText: computed(() => i18n.global.t('validation.messages.disabledCountry')),
};

export default {
    differentRegion,
    disabledCountry,
    restrictedCountry,
    apacOnlyCountry,
};
